import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {FlightService} from "app/services";
import {errorMsg, successMsg} from "app/utils/MessageUtils";

interface DeleteFlightStateParams {
  id: string;
  onSuccess?: Function;
  onError?: Function;
}

export const deleteFlight = (params: DeleteFlightStateParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await FlightService.deleteFlight(params.id);
    if (response.status >= 200 || response.status < 300) {
      dispatch(setSuccess(true));
      dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Flight deleted successfully!' : 'Fluturimi u fshi me sukses!'));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(''));
    }
    dispatch(setLoading(false));
  } catch (err) {
    dispatch(setLoading(false));
    dispatch(errorMsg(err.data.message));
    if (params.onError) params.onError();
    dispatch(setError(err.data.message));
  }
}

interface DeleteFlightSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: DeleteFlightSlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'flights/delete-flight',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setSuccess: (state, action) => {
      state.success = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    }
  }
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;